import { api_urls, date_to_nice_date, get_data_from_url, json_to_upper_case, log } from './utils';

export const SelectPrevClue = (ref) => {
	log('SelectPrevClue')
	clickClue(-1)
	ref.current.focus()
}

export const SelectNextClue = (ref) => {
	log('SelectNextClue');
	clickClue(+1)
	ref.current.focus()
}

export const InitiateSingleClue = () => {
	log('InitiateSingleClue')
	if (document.getElementById('clues-desktop').getElementsByClassName("clue")[0]) {

		let clue_h = document.getElementById('clues-desktop').getElementsByClassName("clue")[0].classList[1]
		//the second clue is always a non-selected one, and the class hash is always the second class.
		//It isn't needed at the moment, but it's a good idea to keep it in mind.
		let clue_non_h = document.getElementById('clues-desktop').getElementsByClassName("clue")[1].classList[1]

		//defining the variable, so it can be used everywhere
		window.$highlight_clue = clue_h
		let clue_desktop_d = document.getElementById('single_clue_container_mobile_clue_desktop')
		clue_desktop_d.style.display = 'block'

		let clue_desktop_m = document.getElementById('single_clue_container_mobile_clue_mobile')
		clue_desktop_m.style.display = 'block'

		initateClasses(clue_desktop_d, clue_desktop_m, clue_h, clue_non_h)

		for (let i = 0; i < document.getElementById('clues-desktop').getElementsByClassName('clue').length; i++) {
			var mut = new MutationObserver(function (mutations, mut) {
				initateClasses(clue_desktop_d, clue_desktop_m, clue_h, clue_non_h)
			});
			mut.observe(document.getElementById('clues-desktop').getElementsByClassName('clue')[i], { 'attributes': true });
		}
	}
}

function initateClasses(clue_desktop_d, clue_desktop_m, clue_h, clue_non_h) {
	for (let element of clue_desktop_d.getElementsByClassName(clue_non_h)) {
		element.style.display = 'none';
	}
	for (let element of clue_desktop_d.getElementsByClassName(clue_h)) {
		element.style.display = 'block';
	}
	for (let element of clue_desktop_m.getElementsByClassName(clue_non_h)) {
		element.style.display = 'none';
	}
	for (let element of clue_desktop_m.getElementsByClassName(clue_h)) {
		element.style.display = 'block';
	}
}

export const LoadFromCache = (crosswordData, ref) => {
	let guesses_storage = JSON.parse(localStorage.getItem('guesses_storage'))
	if (!guesses_storage) {
		log('creating default localStorage: guesses_storage')
		localStorage.setItem('guesses_storage', JSON.stringify([{ date: crosswordData.date, content: {} }]))
	} else {
		if (getCrosswordFromLocalStorage(crosswordData.date) == null) {
			guesses_storage.push({ date: crosswordData.date, content: {} })
			localStorage.setItem('guesses_storage', JSON.stringify(guesses_storage))
		}
		guesses_storage.forEach((item) => {
			if (item.date === crosswordData.date) {
				log('setting data from localStorage (' + crosswordData.date + ')')
				Object.entries(item.content).forEach((guess) => {
					let coords = guess[0].split("_")
					if (guess[1]) {
						try {
							ref.current.setGuess(coords[0], coords[1], guess[1])
						} catch (error) {
							console.log('Attempted to place a "' + guess[1] + '" on coords [' + coords[0] + ',' + coords[1] + "] and failed.")
						}
					}
				})
			}
		})
	}
}

export const getCrosswordFromLocalStorage = (date) => {
	let guesses_storage = JSON.parse(localStorage.getItem('guesses_storage'))
	let found = null
	guesses_storage.forEach((item) => {
		if (item.date === date) {
			found = item
		}
	})
	return found
}

function clickClue(interval) {
	//track all the aria-labels of the clues
	let clues_list = []
	let clues_desktop = document.getElementById('clues-desktop').getElementsByClassName('clue')
	for (let i = 0; i < clues_desktop.length; i++) {
		if (!clues_list.includes(clues_desktop[i].ariaLabel)) {
			clues_list.push(clues_desktop[i].ariaLabel)
		}
	}
	let index_selected = 0

	if (interval !== 0) {
		clues_list.forEach(function (clue, index) {
			if (document.querySelector('[aria-label="' + clue + '"]').className.includes(window.$highlight_clue)) {//class defined in crossword-game.js
				index_selected = index
			}
		})
	}

	//click the desired clue
	if (document.querySelector('[aria-label="' + clues_list[index_selected + interval])) {
		document.querySelector('[aria-label="' + clues_list[index_selected + interval]).click();
	}
}

export const VeureMotsEncreuatsAnteriors = (today) => {
	if (today) {
		log('VeureMotsEncreuatsAnteriors');
		document.getElementById('vilaweb-minimots-history').classList.remove('hidden')
		document.getElementById('vilaweb-minimots-game').classList.add('hidden')
		document.getElementById('vilaweb-minimots-game-empty').classList.add('hidden')
	}
}


export const LoadCrossword = (ref, new_data, setCrosswordData, setOnce) => {
	log('Loading new crossword', new_data);
	if (new_data) {
		setCrosswordData({ 'content': json_to_upper_case(new_data.content), 'date': new_data.date })
		reset(ref)
		document.getElementById('vilaweb-minimots-history').classList.toggle('hidden')
		document.getElementById('vilaweb-minimots-game').classList.toggle('hidden')
		setOnce(false)
	}
}

export const CarregarMotAvui = (setCrosswordData, ref, setOnce) => {
	log("CarregarMotAvui");
	get_data_from_url(api_urls.daily_crossword_url).then((data) => {
		if (data) {
			log(data)
			setCrosswordData({ content: json_to_upper_case(data.content), date: date_to_nice_date(data.date, 'dotted') })
			reset(ref)
			setOnce(false)
		} else {
			LoadDefaultScreen()
		}
	})
}
export const CarregarCustomMot = (customURL, setCrosswordData, ref, setOnce) => {
	log("CarregarCustomMot");
	get_data_from_url(api_urls.daily_crossword_url + "get/special/" + customURL).then((data) => {
		if (data) {
			log(data)
			setCrosswordData({ content: json_to_upper_case(data.content), date: date_to_nice_date(data.date, 'dotted') })
			reset(ref)
			setOnce(false)
		} else {
			LoadDefaultScreen()
		}
	})
}


export const ComprovarMotsEncreuats = () => {
	log('ComprovarMotsEncreuats');
	for (let i = 0; i < document.getElementsByClassName('guess-text-incorrect').length; i++) {
		if (document.getElementsByClassName('guess-text-incorrect')[i].textContent) {
			document.getElementsByClassName('guess-text-incorrect')[i].classList.add("crossed_cell");
		}
	}
	for (let i = 0; i < document.getElementsByClassName('guess-text-correct').length; i++) {
		if (document.getElementsByClassName('guess-text-correct')[i].textContent) {
			document.getElementsByClassName('guess-text-correct')[i].classList.add("correct_cell");
		}
	}
}

export const ResoldreMotsEncreuats = (ref) => {
	log('ResoldreMotsEncreuats');
	ref.current.fillAllAnswers()
}

export const ReiniciarMotsEncreuats = (ref) => {
	log('ReiniciarMotsEncreuats');
	reset(ref)
}

export const EndGame = (set_endgame_modal_open) => {
	log('EndGame');
	let crossword_input = document.querySelector('[aria-label="crossword-input"]')
	if (crossword_input) {
		crossword_input.disabled = true
	}
	set_endgame_modal_open(true)
}

export const LoadDefaultScreen = () => {
	log('LoadDefaultScreen');
	document.getElementById('vilaweb-minimots-game').classList.add('hidden')
	document.getElementById('vilaweb-minimots-game-empty').classList.remove('hidden')
}

function reset(ref) {
	log('Reset');
	if (ref && ref.current) {
		ref.current.reset()
		ref.current.focus()
		document.getElementById("minutes_label_desktop").textContent = "00";
		document.getElementById("seconds_label_desktop").textContent = "00";
		document.getElementById("minutes_label_mobile").textContent = "00";
		document.getElementById("seconds_label_mobile").textContent = "00";
	}
}